// extracted by mini-css-extract-plugin
module.exports = {"left":"PersonalDataLeftPart_left__34d_8"};